export default "__VITE_ASSET__UuuSP$u3__"